import axios from '../utils/axios';

const BASE = '/company-loyalty-settings';

const loyaltySettingsService = {
  get: async () => {
    const response = await axios.get(BASE);
    return response.data;
  },

  save: async (payload) => {
    const response = await axios.put(BASE, payload);
    return response.data;
  },
};

export default loyaltySettingsService;
